import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoNotificationService, PoPageAction, PoTableColumn } from '@po-ui/ng-components';
import { defaultExpedicaoRomaneioItemDto, defaultRomaneioDto, ExpedicaoRomaneioItemDto, RomaneioDto } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';

@Component({
  selector: 'app-romaneio-cliente-validar-carregamento',
  templateUrl: './romaneio-cliente-validar-carregamento.component.html',
  styleUrl: './romaneio-cliente-validar-carregamento.component.css'
})
export class RomaneioClienteValidarCarregamentoComponent implements OnInit {

  apareceInformacoes: boolean = false;
  etiqueta: string = '';
  codigoRomaneio: string = '';

  romaneioMI: boolean = false;
  tituloTable: string = '';

  romaneio: RomaneioDto;
  expedicaoRomaneioItem: ExpedicaoRomaneioItemDto;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private romaneioService: RomaneioService,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
  ) {
    this.expedicaoRomaneioItem = defaultExpedicaoRomaneioItemDto();
    this.romaneio = defaultRomaneioDto();

  }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Romaneio', action: this.goTo.bind(this) },
      { label: 'Lista', action: this.goToLista.bind(this) },
      { label: 'Validar Carregamento' }
    ]
  };

  ngOnInit(): void {
    this.route.params.subscribe((params) => {

      if ('CTIPO' in params){
        if (params['CTIPO'] === 'MI'){
          this.romaneioMI = true;
          this.tituloTable = 'MI'
        } else {
          this.tituloTable = 'Cliente'
        }
      }

      if ('CZ00COD' in params) {
        this.codigoRomaneio = params['CZ00COD'];

        this.romaneioService.getObjectByValue(this.codigoRomaneio).subscribe(romaneio => {
          this.romaneio = romaneio;
          this.romaneio.items = this.romaneio.items.map((item) => {
            return { ...item};
          });
          this.romaneio.itemsRecebidos = this.romaneio.itemsRecebidos.map((item) => {
            return { ...item };
          });
        }, (e) => {
          this.poDialogService.alert({
            title: 'ATENÇÃO',
            message: 'Romaneio Inválido.',
            ok: () => this.goTo()
          });
        });
      }
    });
  }

  goTo(): void {
    this.router.navigateByUrl('');
  }

  goToLista(): void {
    if(this.romaneioMI){
      this.router.navigateByUrl('/estoque/expedicao/romaneio-mi');
    } else {
      this.router.navigateByUrl('/estoque/expedicao/romaneio-cliente');
    }
  }

  public readonly actions: Array<PoPageAction> = [
    { label: 'Gravar', action: this.gravarCarregamento.bind(this)},
  ];

  clickInformacoes(): void {
    this.apareceInformacoes = !this.apareceInformacoes;
  }

  biparEtiqueta(): void {
    this.expedicaoRomaneioItem = defaultExpedicaoRomaneioItemDto();
    let achou = false;
    let loteNaoRetornado = false;
    if (this.etiqueta != '') {
      let etiq = this.etiqueta;
      if (etiq.length > 7 && etiq.substring(0,3) == "000") {
        etiq = etiq.substring(3,etiq.length);
      }

      this.romaneio.items = this.romaneio.items.map((item) => {
        if (item.CZ01ETIQ == etiq) {
          achou = true;

          if (item.CZ03RETLT && item.CZ03RETLT != 'S') {
            loteNaoRetornado = true;
            return item;
          }

          item.CZ01STSCAR = 'A'
          return item;
        } else {
        return item;
           }
      });
      this.etiqueta = '';
      if (!achou) {
        this.poNotificationService.error("Etiqueta Inválida. Etiqueta não pertence ao romaneio.");
      } else if (loteNaoRetornado) {
        this.poNotificationService.error("Lote ainda nao Retornado do Controle de Danos");
      }
    }
  }

  public readonly colunas: Array<PoTableColumn> = [
    {property: 'CZ01STSCAR',label: 'Status Carregamento',width: '8%', type: 'subtitle', visible: true,
      subtitles: [
        {value: 'P', color: 'color-01', content: 'P', label: 'Pendente'},
        {value: 'A', color: 'color-10', content: 'A', label: 'Autorizado'},
      ]
    },
    {property: 'CZ01ETIQ' , label: 'Etiqueta'},
    {property: 'CB1COD'   , label: 'Produto'},
    {property: 'CB1DESC'  , label: 'Descrição'},
    {property: 'NZ01QUANT', label: 'Quantidade'},
  ];

  public readonly colunasRecebidos: Array<PoTableColumn> = [
    {property: 'CZ01ETIQ' , label: 'Etiqueta'},
    {property: 'CB1COD'   , label: 'Produto'},
    {property: 'CB1DESC'  , label: 'Descrição'},
    {property: 'NZ01QUANT', label: 'Quantidade'}

  ];


  gravarCarregamento(): void {
    this.romaneioService.postControleCarregamento(this.romaneio).subscribe({
      next: (ret) => {
        this.poNotificationService.success(`Etiquetas atualizadas com sucesso!`);
        if(this.romaneioMI){
          this.router.navigateByUrl('/estoque/expedicao/romaneio-mi');
        } else {
          this.router.navigateByUrl('/estoque/expedicao/romaneio-cliente');
        }
      }
    });
  }

}
